import { AnyFieldMeta } from '@tanstack/react-form';
import AlertCircleOutline from 'mdi-material-ui/AlertCircleOutline';

type FieldErrorsProps = {
	meta: AnyFieldMeta;
	name: string;
	hideErrors?: boolean;
	className?: string;
	showAllErrors?: boolean; // if true, show all errors instead of just the first
};

export const FieldErrors = ({
	meta,
	name,
	hideErrors,
	className,
	showAllErrors = false,
}: FieldErrorsProps) => {
	if (hideErrors) return null;

	// strip out any errors that have the same message
	const uniqueErrors = [...new Set(meta.errors.map((err) => err.message))];
	if (uniqueErrors.length === 0) return null;

	// if there is more than one error and showAllErrors is false, show the last error only
	const errorsToShow =
		showAllErrors && uniqueErrors.length > 1
			? uniqueErrors
			: [uniqueErrors[uniqueErrors.length - 1]];

	return (
		<div id={`${name}-error`} className={`${className}`}>
			{errorsToShow.map((message, index) => (
				<p key={index} className='mt-2 text-base text-error'>
					<AlertCircleOutline
						className='pr-2 mt-[-3px]'
						data-test-id='AlertCircleOutlineIcon'
						aria-hidden='true'
					/>
					{message}
				</p>
			))}
		</div>
	);
};
